import { createTheme } from '@mui/material/styles'

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#009FDA',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#FF4D4F',
    },
    info: {
      main: '#8E8E8E',
    },
  },
})

export { theme }
